import React from 'react'
import Question_ from "../assets/Question.png";
import multi_choices from "../assets/multi_choices.jpg";
import PieChart from "./PieChart";
import { useState, useEffect } from 'react';
import axios from 'axios';
import { QuestionTypes } from '../constants';
import { useParams } from 'react-router-dom';
import { BASE_URL } from "../constants";

export default function MultiChoicesAnswerAnalysis({ question }) {
    const { id } = useParams();
    const [answers, setAnswers] = useState({ options: [], count: 1, correct: 0, inCorrect: 0, noAnswer: 0, answers: [] });

    useEffect(() => {
        const fetchAswer = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/lesson/questionAllAnswers.php?questionId=${question.id}&lessonId=${id}`);
                setAnswers(response?.data);
            } catch (err) {
                console.log("error: ", err);
            }
        }
        fetchAswer();
        const interval = setInterval(fetchAswer, 5000);
        return () => {
            clearInterval(interval);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [question.id])

    return <div className=" question-overlay flex flex-col gap-4">

        {/* type */}
        <div className="flex items-center gap-2">
            <div className="question-img">
                <img src={question.type == QuestionTypes.multiChoices ? multi_choices : Question_} alt="Icon" />
            </div>
            <p className='m-0 text-xl font-semibold'> {question.type == QuestionTypes.multiChoices ? `Multi Choices Question (${answers.total})` : `Open Ended Question (${answers.total})`}</p>
        </div>

        {/* title */}
        <div className="flex max-md:flex-col flex-column flex-lg-row gap-4 justify-between">
            <p className='m-0 fs-3 font-bold max-md:text-center'>{question.questionBody}</p>
            <div className='flex gap-2 justify-content-center justify-content-lg-end items-center text-lg'>
                <p className='m-0'> Correct  <span style={{ color: "green" }}> {(answers.correct || 0).toFixed(1)}% </span></p>
                <span>|</span>
                <p className='m-0'> Incorrect <span style={{ color: "red" }}>  {(answers.inCorrect || 0).toFixed(1)}% </span></p>
                <span>|</span>
                <p className='m-0'> No Answer <span style={{ color: "gray" }}>  {(answers.noAnswer || 0).toFixed(1)}% </span></p>
            </div>
        </div>
        <div className="flex justify-center align-items-center ">
            <div class="table-responsive"
                style={{
                    minHeight: "87px"
                }}
            >
                <table class="table"
                    style={{
                        width: "max-content",
                        marginBottom: 0
                    }}
                >
                    <thead>
                        <tr>
                            <th scope="col">Answers</th>
                            {answers.options.map((ele, idx) => <th scope="col">{ele.option_body}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Selection %</td>
                            {answers.options.map((ele, idx) => <td>{(ele.count * 100 / (answers.count || 1)).toFixed(1)}%</td>)}

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className='mx-auto' >
            <PieChart chartData={answers} />
        </div>

        <div className='font-semibold text-lg w-3/4 mx-auto flex flex-col gap-1'>
            <div className="grid grid-cols-3">
                <div className="flex justify-center">No. </div>
                <div className="flex justify-center">Student</div>
                <div className="flex justify-center">Answer</div>
            </div>
            <div className='border-b-lightAqua border-b' />
            {
                Object.values(answers?.answers)?.map((data, idx) =>
                    <div className='flex flex-col gap-1' key={idx}>
                        <div className="grid grid-cols-3">
                            <div className="flex justify-center"> {idx + 1}</div>
                            <div className="flex justify-center"> {data?.fullname}</div>
                            <div className="flex justify-center flex-column ">{answers.options.filter(op => data.answer?.split('|')?.includes(`${op?.id}`)).map(op => <div
                                style={{
                                    color: ((op?.istrue ?? 0) - 0) ? "green" : "red",
                                }}
                            >{op.option_body}</div>)}</div>
                        </div>
                        <div className='border-b-lightAqua border-b' />
                    </div>
                )
            }
        </div>

    </div>
}
